import { TranslateService } from '@ngx-translate/core';

import { BookingTypeEnum } from '../enums/booking-type-enum';

export function getDropdownValue(value: string): any {
  return {
    key: value.trim(),
    value: value.trim(),
  };
}

function newDropdownValue(value: string, translateService: TranslateService): any {
  return {
    key: value,
    value: translateService.instant(value),
  };
}

export function getDropdownValues(values: any[], translateService: TranslateService): any[] {
  const dropdownValues: any[] = [];
  for (const value of values) {
    dropdownValues.push(newDropdownValue(value, translateService));
  }
  return dropdownValues;
}

export function dropdownValuesHandler(values: any[]): any[] {
  const dropdownValues: any[] = [];
  for (const value of values) {
    dropdownValues.push(getDropdownValue(value));
  }
  return dropdownValues;
}

export function getBookingTypeDropdownValue(bookingType: any, translateService: TranslateService): any {
  if (bookingType === BookingTypeEnum.CREDIT || bookingType === BookingTypeEnum.DEBIT) {
    return {
      key: bookingType,
      value: translateService.instant(bookingType),
    };
  }
}

export function getAdditionalCostsCategoryDropdownList(
  categoryId: number,
  categoryName: string,
  translateService: TranslateService,
): any {
  return {
    key: categoryId,
    value: translateService.instant(categoryName),
  };
}
